import React from 'react';
import { Helmet, HelmetData } from 'react-helmet-async';

import Nav from '../Nav';

import './style.css';

const helmetData = new HelmetData({});

function Content(props) {
    return (
        <div className="hero-home">
            <Helmet helmetData={helmetData}>
                <title>{props.title}</title>
            </Helmet>

            <span className="hero-icon" />

            <h1 className="home-title">{props.title}</h1>
            <p className="home-blurb" dangerouslySetInnerHTML={{__html: props.body}} />
        </div>
    );
}

export default function Hero(props) {
    return (
        <section className="hero">
            <Helmet helmetData={helmetData}>
                <title>Alex Duckmanton</title>
                <meta name="description" content="I’m a product designer based in Sydney" />
                <meta name="theme-color" content="#ffffff" />
            </Helmet>

            {props.page === 'home' &&
                <Content
                page="home"
                title="Alex Duckmanton"
                body="I’m a product designer with 15+ years of experience. I help teams ship from discovery to launch, covering research and UX through to UI, prototyping, and testing."
            />
            }

            {props.page === 'resume' &&
                <Content
                    page="resume"
                    title="Resume"
                    body="On top of my day-to-day work, I also like to pick up freelance jobs when I can — I’ve worked with Barnardo’s in the UK and community radio station 3RRR in Melbourne."
                />
            }

            {props.page === 'error' && 
                <Content
                    page="error"
                    title="404"
                    body="Oh no"
                />
            }

            <Nav className="home" page={props.page} />

        </section>
    );
}
